export const items = [
  {
    id: 0,
    name: "Cobol",
  },
  {
    id: 1,
    name: "JavaScript",
  },
  {
    id: 2,
    name: "Basic",
  },
  {
    id: 3,
    name: "PHP",
  },
  {
    id: 4,
    name: "Java",
  },
];

export const autoCompleteConstants = {
  AUTO_COMPLETE_REQUEST: "AUTO_COMPLETE_REQUEST",
  AUTO_COMPLETE_RESULT: "AUTO_COMPLETE_RESULT",
  AUTO_COMPLETE_FAILURE: "AUTO_COMPLETE_FAILURE",
  AUTO_COMPLETE_FROM_REQUEST: "AUTO_COMPLETE_FROM_REQUEST",
  AUTO_COMPLETE_FROM_SUCCESS: "AUTO_COMPLETE_FROM_RESULT",
  AUTO_COMPLETE_TO_REQUEST: "AUTO_COMPLETE_TO_REQUEST",
  AUTO_COMPLETE_TO_SUCCESS: "AUTO_COMPLETE_TO_RESULT",
  AUTO_COMPLETE_RESET_REQUEST: "AUTO_COMPLETE_RESET_REQUEST",
};